import { Session, SessionSummary } from '../entities';
import { ISessionRepository } from '../../data/repositories/ISessionRepository';

export interface GetMySessionsRequest {
  userId: number;
  limit?: number;
  offset?: number;
  status?: 'all' | 'open' | 'closed';
}

export interface GetMySessionsResponse {
  sessions: Session[];
  summary: SessionSummary;
  totalCount: number;
}

export class GetMySessions {
  constructor(private sessionRepository: ISessionRepository) {}

  async execute(request: GetMySessionsRequest): Promise<GetMySessionsResponse> {
    const { userId, limit = 50, offset = 0, status = 'all' } = request;

    // Получаем сессии в зависимости от статуса
    let sessions: Session[];
    switch (status) {
      case 'open':
        sessions = await this.sessionRepository.getOpenSessionsForUser(userId);
        break;
      case 'closed':
        sessions = await this.sessionRepository.getClosedSessionsForUser(userId);
        break;
      default:
        sessions = await this.sessionRepository.getAllSessionsForUser(userId);
    }

    // Применяем пагинацию
    const paginatedSessions = sessions.slice(offset, offset + limit);

    // Вычисляем статистику
    const summary = this.calculateSummary(sessions);

    return {
      sessions: paginatedSessions,
      summary,
      totalCount: sessions.length
    };
  }

  private calculateSummary(sessions: Session[]): SessionSummary {
    const totalSessions = sessions.length;
    const totalHours = sessions.reduce((total, session) => {
      if (session.duration) {
        return total + (session.duration / 3600); // конвертируем секунды в часы
      }
      return total;
    }, 0);
    
    const averageRate = sessions.length > 0 
      ? sessions.reduce((total, session) => total + (session.rate || 0), 0) / sessions.length
      : 0;

    return {
      totalSessions,
      totalHours: Math.round(totalHours * 100) / 100, // округляем до 2 знаков
      averageRate: Math.round(averageRate * 100) / 100
    };
  }
}
